const initstate = {
  projects: [
    { id: 1, Title: 'help me find' },
    { id: 1, Title: 'help me find' },
    { id: 1, Title: 'help me find' }
  ]
};

const authReducer = (state = initstate) => {
  return state;
}

export default authReducer;
